// @ts-ignore
import { PROBLEM_INNER_TYPES, PROBLEM_STATUS_DISPLAY_NAMES } from '@yandex-int/k-common/constants';
import { StudentProblemResult, LessonProblem } from '@yandex-int/k-common/typings';

import { isOpenAnswer } from 'store/problems/utils';
import { getOpenAnswerUrl } from 'utils/open-answer';

import { PROBLEM_DISPLAY_STATUS } from './typings';

// eslint-disable-next-line complexity
export const getProblemDisplayStatus = (
    problemLessonLink: LessonProblem,
    problemResult: StudentProblemResult | null
): PROBLEM_DISPLAY_STATUS => {
    if (!problemResult) {
        return PROBLEM_DISPLAY_STATUS.NOT_SOLVED;
    }

    const isTheory = problemResult.type === PROBLEM_INNER_TYPES.THEORY;

    if (isTheory) {
        const hasTime = Boolean(problemResult.time);
        return hasTime ? PROBLEM_DISPLAY_STATUS.SEEN : PROBLEM_DISPLAY_STATUS.NOT_SEEN;
    }

    if (isOpenAnswer(problemLessonLink?.problem)) {
        const resultLink = getOpenAnswerUrl(problemResult);
        return resultLink ? PROBLEM_DISPLAY_STATUS.SEEN : PROBLEM_DISPLAY_STATUS.NOT_SEEN;
    }

    switch (problemResult.status) {
        case PROBLEM_STATUS_DISPLAY_NAMES.CORRECT:
            return PROBLEM_DISPLAY_STATUS.CORRECT;
        case PROBLEM_STATUS_DISPLAY_NAMES.INCORRECT:
            return PROBLEM_DISPLAY_STATUS.INCORRECT;
        case PROBLEM_STATUS_DISPLAY_NAMES.NOT_EVALUATED:
        case PROBLEM_STATUS_DISPLAY_NAMES.ANSWERED:
            return PROBLEM_DISPLAY_STATUS.SOLVED;
        default:
            return PROBLEM_DISPLAY_STATUS.NOT_SOLVED;
    }
};
